import { intervalToDuration, differenceInYears, parse, format } from 'date-fns';
const eventDate = '27/09/2026';

export const ageService = {
    calculateAge,
    calculateFullAge,
    formatDate,
};

function calculateAge(dob) {
    const eventdate = parse(eventDate, 'dd/MM/yyyy', new Date());
    const DOB = parse(dob, 'yyyy-MM-dd', new Date());
    const age = differenceInYears(eventdate, DOB);
    return age;
}

function calculateFullAge(dob) {
    const eventdate = parse(eventDate, 'dd/MM/yyyy', new Date());
    const DOB = parse(dob, 'yyyy-MM-dd', new Date());
    const { years, months, days } = intervalToDuration({ start: DOB, end: eventdate});
    return { years, months, days };
}

function formatDate(date) {
    const result = format(new Date(date), 'dd/MM/yyyy');
    return result;
}